module.exports = __webpack_public_path__ + "img/BS37.fa94738b.svg";